export default "__VITE_ASSET__Dm3jqI4g__"